import {
  FOOTER_PRODUCT_LINKS,
  HEADER_CTA,
  HEADER_LINKS,
} from '@/features/home/constants/home.constants';
import type { SiteLink } from '@/types/home.types';

interface UsePublicLayoutResult {
  headerLinks: SiteLink[];
  headerCta: SiteLink;
  footerProductLinks: SiteLink[];
  year: number;
}

export const usePublicLayout = (): UsePublicLayoutResult => ({
  headerLinks: HEADER_LINKS,
  headerCta: HEADER_CTA,
  footerProductLinks: FOOTER_PRODUCT_LINKS,
  year: new Date().getFullYear(),
});
